module.exports = __webpack_public_path__ + "static/img/pepper.dad93dd0.webp";